import { DEFAULT_FIVERR_LOCALE, SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';
import { LOCALES, LOCALES_LABELS } from '../../utils/constants';
import subtitlesSrc from './subtitles_en.vtt';

export const VIDEO_ASSETS = {
    [DEFAULT_FIVERR_LOCALE]: {
        desktop:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/4934b0c8f6441211d97f83585a7c9c00-1722433273322/Vontelle%20Cutdown-%20Breakthrough%20V5',
        mobile: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/03e1ef43201724755eceea67985317b2-1722432611137/Vontelle%20Breakthrough%209x16',
        subtitles: [
            {
                src: subtitlesSrc,
                label: LOCALES_LABELS[LOCALES.en],
                srcLang: LOCALES.en,
            },
        ],
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE]: {
        subtitles: [],
        desktop:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/4934b0c8f6441211d97f83585a7c9c00-1722433273322/Vontelle%20Cutdown-%20Breakthrough%20V5',
        mobile: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/03e1ef43201724755eceea67985317b2-1722432611137/Vontelle%20Breakthrough%209x16',
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.ES]: {
        subtitles: [],
        desktop:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/4934b0c8f6441211d97f83585a7c9c00-1722433273322/Vontelle%20Cutdown-%20Breakthrough%20V5',
        mobile: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/03e1ef43201724755eceea67985317b2-1722432611137/Vontelle%20Breakthrough%209x16',
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.FR_FR]: {
        subtitles: [],
        desktop:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/4934b0c8f6441211d97f83585a7c9c00-1722433273322/Vontelle%20Cutdown-%20Breakthrough%20V5',
        mobile: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/03e1ef43201724755eceea67985317b2-1722432611137/Vontelle%20Breakthrough%209x16',
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.PT_BR]: {
        subtitles: [],
        desktop:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/4934b0c8f6441211d97f83585a7c9c00-1722433273322/Vontelle%20Cutdown-%20Breakthrough%20V5',
        mobile: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/03e1ef43201724755eceea67985317b2-1722432611137/Vontelle%20Breakthrough%209x16',
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.IT_IT]: {
        subtitles: [],
        desktop:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/4934b0c8f6441211d97f83585a7c9c00-1722433273322/Vontelle%20Cutdown-%20Breakthrough%20V5',
        mobile: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/03e1ef43201724755eceea67985317b2-1722432611137/Vontelle%20Breakthrough%209x16',
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.NL_NL]: {
        subtitles: [],
        desktop:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/4934b0c8f6441211d97f83585a7c9c00-1722433273322/Vontelle%20Cutdown-%20Breakthrough%20V5',
        mobile: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/03e1ef43201724755eceea67985317b2-1722432611137/Vontelle%20Breakthrough%209x16',
    },
};

export const VIDEO_PLACEHOLEDER =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ef51b45f79342925d5268e0b2377eae8-1704717764992/thumbnail.png';
